import { useTalent } from "../../../providers/TalentProvider";
import ProfileContainer from "../components/ProfileContainer";

const TalentProfileProjectInterests = () => {
    const { talent } = useTalent();

    return (
        <ProfileContainer>
            <div id="project-interests">
                <h4 className="text-bold font-xl pb-6">Project Interests</h4>

                <div className="fle gap-6">
                    <div className="flex-1">
                        <p dangerouslySetInnerHTML={{ __html: talent.project_interest }} className="whitespace-pre-wrap" />
                    </div>

                </div>
            </div>

            <div id="selected-interests" className="flex flex-wrap flexcol gap-6 wfull">
                {!!talent.talent_service_groups?.length ? (
                    <div className="pt-8">
                        <div className="mdw-full">
                            <h4 className="text-bold text-xl pb-6">Selected Interests</h4>
                        </div>

                        {/* <div className="flex flex-wrap gap-6"> */}
                        {/* <div className="grid grid-cols-2 gap-6"> */}
                        <div className="columns-2 gap-6">
                            {TB.map(TB.groupBy(talent.talent_service_groups, 'category.name'), (services, category_name) => {
                                return (
                                    <div key={category_name} className="w-full pb-8">
                                        <h5 className="font-secondary text-primary text-xs font-bold uppercase">{category_name}</h5>

                                        <div className="flex flex-col items-start gap-x4 gap-y-3 pt-4">
                                            {services.map(service => (
                                                // <div key={service.id} className="bg-wrippleOffWhite py-2.5 px-4 inline-block my-1.5">
                                                <div key={service.id} className="bg-wrippleOffWhite py-0.5 px-2 inline-block shadow">
                                                    <p>
                                                        {service.name}
                                                    </p>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                ) : (
                    <h3 className="text-danger">
                        N/A
                    </h3>
                )}
            </div>
        </ProfileContainer>
    )
}

export default TalentProfileProjectInterests;